module.exports = __webpack_public_path__ + "static/media/green-curve.3d23b2f3.svg";